import jwtService from './jwtService.js'

export default jwtService
